import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IProps as IUploadFileProps } from '../../../components/UploadFile';

export interface IFilesUploadProps extends IUploadFileProps {
  visible?: boolean;
}

export const generate = (
  props?: Partial<IComponentSchema<IFilesUploadProps>>
): IComponentSchema<IFilesUploadProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.ARRAY,
    name: props?.name || id,
    title: props?.title || 'Upload',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FilesUpload,
    'x-component-props': {
      label: 'Upload File',
      type: 'primary',
      size: 'middle',
      multiple: false,
      showUploadList: false,
      visible: true,
    },
    'x-component-props-config': {},
  };
};
